/**
 * Contenu centralisé pour le dispositif de consentement OpenData.
 * Réutilisé par la popup, le formulaire acteur, le bandeau de rappel et le message de masse.
 */

export const OPEN_DATA_PORTAL_URL = 'https://opendata.agglo-larochelle.fr';
export const OPEN_DATA_LICENSE_URL = 'https://fr.wikipedia.org/wiki/Open_Database_License';

/** Identifiant de l'ancre + paramètre d'URL utilisés pour mettre la section en évidence. */
export const OPEN_DATA_SECTION_ID = 'opendata-section';
export const OPEN_DATA_FOCUS_PARAM = 'opendata';

export const openDataContent = {
  title: 'Gagnez en visibilité avec l’OpenData',

  /** Accroche affichée en tête (popup + formulaire). */
  intro:
    'Ouaaa-Transition vous propose de mettre à disposition vos données sur le portail ' +
    'opendata.agglo-larochelle.fr selon la licence ODbL. Vous choisissez ce que vous publiez :',

  /** Libellés des deux cases. */
  agendaLabel: 'Publier mes données d’agenda + le nom de ma structure',
  agendaHelp:
    'Vos événements (dates, lieu, intitulé) et le nom de votre structure deviennent réutilisables, ' +
    'par exemple pour alimenter automatiquement un agenda unifié.',

  actorLabel: 'Publier mes données d’acteur (nom, localisation, thématiques, etc.)',
  actorHelp:
    'Votre fiche acteur (nom, localisation, thématiques, coordonnées publiques…) devient réutilisable ' +
    'par d’autres plateformes et services.',

  /** Argument incitatif (donner envie). */
  benefit:
    'L’OpenData rend vos données réutilisables par des machines pour de nouveaux services et les fait ' +
    'circuler d’un outil à l’autre. Concrètement, vos infos peuvent remonter sur le site de l’Agglo de ' +
    'La Rochelle puis dans les différents agendas partenaires : vous gagnez en visibilité et vous ' +
    'simplifiez votre communication, sans la ressaisir partout.',

  /** Réassurance. */
  reassurance:
    'Vous retrouvez ces deux paramètres dans votre profil d’acteur et pouvez retirer vos autorisations ' +
    'à tout moment.',

  /** Message adapté pour les acteurs qui avaient coché l’ancien OpenData. */
  legacyReminder:
    'Vous aviez déjà autorisé l’OpenData sous nos précédentes conditions. La licence a été clarifiée ' +
    '(ODbL) et scindée en deux choix distincts : merci de re-confirmer ci-dessous les données que vous ' +
    'souhaitez continuer à partager.',

  licenseHint: 'Licence ODbL (Open Database License) — en savoir plus',
} as const;
